import {
  withTranslation,
} from 'react-i18next';

import BoatRentsSectionView from './BoatRentsSectionView';

const TranslatedComponent = withTranslation()(BoatRentsSectionView);

const Component = TranslatedComponent;

export default Component;
